<template>
  <FieldBox :title="title" class="loss-price">
    <PlusMinusInput
      v-model="stopLossPrice"
      :precision="precision"
      :step="minTick"
      :min="0"
      :max="999999999"
      :match-tick="true"
      :match-precision="true"
    />
  </FieldBox>
</template>
<script>
import { mapGetters } from 'vuex'
import PlusMinusInput from 'com/PlusMinusInput'
import FieldBox from '../FieldBox'
import getPriceMinTick from 'utils/getPriceMinTick'
import getPriceAccuracy from 'utils/getPriceAccuracy'

export default {
  name: 'AttachProfitPriceField',
  components: {
    FieldBox,
    PlusMinusInput
  },
  props: {
    minTicks: Array
  },
  computed: {
    ...mapGetters(['tradeRequest']),
    order() {
      return this.tradeRequest.order
    },
    title() {
      return this.$t('trade.stop-loss-price')
    },
    minTick() {
      return getPriceMinTick(this.stopLossPrice, this.minTicks)
    },
    precision() {
      return getPriceAccuracy(this.minTick)
    },
    stopLossPrice: {
      get() {
        return this.order.stopLossPrice
      },
      set(price) {
        this.$store.dispatch('updateTradeOrder', {
          stopLossPrice: price
        })
      }
    }
  }
}
</script>
